"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: insights/insights-enum.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Finsights%2Finsights-enum.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.personalityToJSON = exports.personalityFromJSON = exports.intervalToJSON = exports.intervalFromJSON = exports.Personality = exports.Interval = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.insights.proto';
/**
 * Decides which type of report the server should pull.
 */
var Interval;
(function (Interval) {
    Interval["INVALID_INTERVAL"] = "INVALID_INTERVAL";
    Interval["YEAR"] = "YEAR";
    Interval["QUARTER"] = "QUARTER";
    Interval["MONTH"] = "MONTH";
    Interval["WEEK"] = "WEEK";
    Interval["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Interval || (exports.Interval = Interval = {}));
var Personality;
(function (Personality) {
    Personality["INVALID_PERSONALITY"] = "INVALID_PERSONALITY";
    Personality["THE_FOODIE"] = "THE_FOODIE";
    Personality["THE_JET_SETTER"] = "THE_JET_SETTER";
    Personality["THE_TREND_SETTER"] = "THE_TREND_SETTER";
    Personality["THE_SOCIALITE"] = "THE_SOCIALITE";
    Personality["THE_RESPONSIBLE_ONE"] = "THE_RESPONSIBLE_ONE";
    Personality["THE_GAMER"] = "THE_GAMER";
    Personality["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Personality || (exports.Personality = Personality = {}));
function intervalFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_INTERVAL':
            return Interval.INVALID_INTERVAL;
        case 1:
        case 'YEAR':
            return Interval.YEAR;
        case 2:
        case 'QUARTER':
            return Interval.QUARTER;
        case 3:
        case 'MONTH':
            return Interval.MONTH;
        case 4:
        case 'WEEK':
            return Interval.WEEK;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Interval.UNRECOGNIZED;
    }
}
exports.intervalFromJSON = intervalFromJSON;
function intervalToJSON(object) {
    switch (object) {
        case Interval.INVALID_INTERVAL:
            return 'INVALID_INTERVAL';
        case Interval.YEAR:
            return 'YEAR';
        case Interval.QUARTER:
            return 'QUARTER';
        case Interval.MONTH:
            return 'MONTH';
        case Interval.WEEK:
            return 'WEEK';
        case Interval.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.intervalToJSON = intervalToJSON;
function personalityFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_PERSONALITY':
            return Personality.INVALID_PERSONALITY;
        case 1:
        case 'THE_FOODIE':
            return Personality.THE_FOODIE;
        case 2:
        case 'THE_JET_SETTER':
            return Personality.THE_JET_SETTER;
        case 3:
        case 'THE_TREND_SETTER':
            return Personality.THE_TREND_SETTER;
        case 4:
        case 'THE_SOCIALITE':
            return Personality.THE_SOCIALITE;
        case 5:
        case 'THE_RESPONSIBLE_ONE':
            return Personality.THE_RESPONSIBLE_ONE;
        case 6:
        case 'THE_GAMER':
            return Personality.THE_GAMER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Personality.UNRECOGNIZED;
    }
}
exports.personalityFromJSON = personalityFromJSON;
function personalityToJSON(object) {
    switch (object) {
        case Personality.INVALID_PERSONALITY:
            return 'INVALID_PERSONALITY';
        case Personality.THE_FOODIE:
            return 'THE_FOODIE';
        case Personality.THE_JET_SETTER:
            return 'THE_JET_SETTER';
        case Personality.THE_TREND_SETTER:
            return 'THE_TREND_SETTER';
        case Personality.THE_SOCIALITE:
            return 'THE_SOCIALITE';
        case Personality.THE_RESPONSIBLE_ONE:
            return 'THE_RESPONSIBLE_ONE';
        case Personality.THE_GAMER:
            return 'THE_GAMER';
        case Personality.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.personalityToJSON = personalityToJSON;
//# sourceMappingURL=insights-enum.js.map